/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import classNames from 'classnames';
import React from 'react';

import {EnzymeAttributes} from 'molbio/enzymes/backbone/Enzymes';

import EnzymeActivityTable from './EnzymeActivityTable';
import {Provider} from './EnzymeConstants';
import EnzymeProviderSelector from './EnzymeProviderSelector';

export interface EnzymeActivityTableWithProviderSelectorProps {
  enzymes: Array<EnzymeAttributes>;
  provider: Provider;
  onChangeProvider: (provider: Provider) => void;
  providers: Array<Provider>;
  small: boolean;
  pullSelectorRight?: boolean;
}

export default function EnzymeActivityTableWithProviderSelector({
  enzymes,
  onChangeProvider,
  provider,
  providers,
  pullSelectorRight = false,
  small,
}: EnzymeActivityTableWithProviderSelectorProps): JSX.Element {
  return (
    <div className="u-tiny-spacing-top u-small-text">
      <div className={classNames({'pull-right': pullSelectorRight})}>
        <EnzymeProviderSelector
          providers={providers}
          value={provider}
          onChange={onChangeProvider}
          small={small}
          inline={true}
        />
      </div>
      <EnzymeActivityTable enzymes={enzymes} provider={provider} small={small} />
    </div>
  );
}
